module.exports = __webpack_public_path__ + "img/img2.8f594620.jpg";